import * as _ from 'lodash';
import { Component, FormEvent } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ICenterState, DashActionCreators, IVariableReportListResponse, IVariableReportLookUpResponse, IVariableTextResponse } from '@nkr/store/index';
import { ILanguageVariableReportLookupData, ILanguageRequest, ILanguageVariableList, ILanguageVariableFilterRequest } from '@nkr/models/index';
import { Button, Col, ControlLabel, FormControl, Label, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react';
import { IHeaderParams, GridApi, ColumnApi, CellClickedEvent, GridReadyEvent, ColDef, SortChangedEvent, FirstDataRenderedEvent } from 'ag-grid-community';
import { ICellRendererParams } from 'ag-grid-community'
import { FormGroupWrapper, GridWrapper } from './styles';
import { AxiosError } from 'axios';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import Filter from './filter';
import RankRenderer from '@nkr/views/admin/center/list/common/rank-renderer'

interface IProps { }

interface IStateProps {
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getFilteredVariableReportList: (request: ILanguageVariableFilterRequest) => Promise<IVariableReportListResponse>,
    getVariableReportList: () => Promise<IVariableReportListResponse>,
    getVariableReportLookupData: () => Promise<IVariableReportLookUpResponse>,
    getVariableText: (request: ILanguageRequest) => Promise<IVariableTextResponse>,
    saveVariableRecord: (request: ILanguageRequest) => Promise<IVariableReportListResponse>,
    deleteVariableRecord: (variableId: number) => Promise<any>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    text: boolean,
    variable: boolean
}

interface IState {
    lookupData: ILanguageVariableReportLookupData,
    listData: ILanguageVariableList[],
    internalExternal: number,
    search: string,
    missingLanguageId: number,
    centerId: number,
    view: {
        show: boolean,
        modalHeight: string,
        formData: ILanguageRequest
    },
    deleteConfim:
    {
        show: boolean,
        modalHeight: string,
        variableId: number
    },
    minHeight: number,
    validation: {
        text: boolean,
        variable: boolean
    },
    dirty: boolean
}

class VariableList extends Component<TProps, IState> {
    readonly state: IState = {
        lookupData: {
            languageList: [],
        },
        listData: [],
        internalExternal: 0,
        search: '',
        missingLanguageId: 999,
        centerId: 0,
        view: {
            show: false,
            modalHeight: '',
            formData: {
                languageId: 0,
                variableId: 0,
                variable: '',
                text: ''
            }
        },
        deleteConfim: {
            show: false,
            modalHeight: '',
            variableId: 0
        },
        minHeight: 200,
        validation: {
            text: true,
            variable: true
        },
        dirty: false
    }

    gridApi: GridApi;
    columnApi: ColumnApi;
    container: HTMLDivElement;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;

        //e.api.sizeColumnsToFit();
    }

    onGridSizeChanged = () => {
        this.gridApi.sizeColumnsToFit();
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        this.getData();
    }

    columns: ColDef[] = [
        {
            colId: 'Rank',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            headerName: 'Rank',
            width: 75,
            sortable: false,
            cellRendererFramework: (params: ICellRendererParams) => <RankRenderer {...params} />,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            headerClass: 'language-list-header'
        },
        {
            field: 'variable',
            headerName: 'Variable',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Variable
                </SortableHeaderComponent>,
            sortable: true,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            width: 400,
            headerClass: 'language-list-header'
        },
        {
            field: 'languages',
            headerName: 'Languages',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Languages
                </SortableHeaderComponent>,
            sortable: true,
            width: 300,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            headerClass: 'language-list-header'
        }
    ];

    getData = () => {
        this.props.showLoading('Loading variable report, one moment please...').then(() => {
            return Promise.all([
                this.props.getVariableReportLookupData(),
                this.props.getVariableReportList(),
            ])
                .then(([lookUpResponse, reportListResponse]) => {
                    if (lookUpResponse.data.success) {
                        let lookupData = lookUpResponse.data.results;

                        let listData = reportListResponse.data.results;

                        this.setState({
                            lookupData,
                            listData
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    filteredData = () => {
        let variablereports = this.state.listData.filter(report => {
            let missingLanguageId = this.state.missingLanguageId > 0 ? report.id == this.state.missingLanguageId : true;

            let search = (this.state.search != '' ? report.variable.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true);

            return missingLanguageId && search;
        })

        return variablereports;
    }

    handleSearchChange = (search: string) => {
        this.setState({
            search
        });
    }

    handleMissingLanguageChange = (missingLanguageId: number) => {
        this.setState({
            missingLanguageId
        });
    }

    handleAddVariableReport = () => {
        this.setState({
            view: {
                show: true,
                modalHeight: '25vw',
                formData: {
                    languageId: 0,
                    variableId: 0,
                    text: "",
                    variable: ""
                }
            }
        });
    }

    handleEditVariableReport = (variableId: number) => {
        let variableRecord = this.state.listData.find(x => x.id == variableId);

        this.setState({
            view: {
                show: true,
                modalHeight: '70vw',
                formData: {
                    variableId: variableRecord.id,
                    languageId: 1,
                    text: variableRecord.defaultText,
                    variable: variableRecord.variable
                }
            }
        });
    }

    handleDeleteModal = (variableId: number) => {
        this.setState({
            deleteConfim: {
                show: true,
                modalHeight: '70vw',
                variableId
            }
        });
    }

    handleAddEditSave = () => {
        let variableReport = this.state.view.formData;
        let validation = this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                this.props.showLoading('Saving variable report, one moment please...').then(() => {
                    this.props.saveVariableRecord(variableReport)
                        .then(response => {
                            if (response.data.success) {
                                toast.success('Successfully saved the variable report', { autoClose: 5000 })
                            }

                            let { search, missingLanguageId } = this.state;

                            let filterRequest: ILanguageVariableFilterRequest = {
                                languageMissing: missingLanguageId,
                                variable: search
                            };

                            this.props.getFilteredVariableReportList(filterRequest).then((response) => {
                                if (response.data.success) {
                                    let listData = response.data.results;

                                    this.setState({
                                        listData,
                                        view: {
                                            show: true,
                                            modalHeight: '',
                                            formData: variableReport.variableId > 0 ? this.state.view.formData :
                                                {
                                                    languageId: 0,
                                                    variableId: 0,
                                                    text: "",
                                                    variable: ""
                                                }
                                        },
                                        validation: {
                                            text: true,
                                            variable: true
                                        }
                                    });
                                }
                            });
                        })
                        .catch((error: AxiosError) => {
                            toast.error("Unable to process request: " + error.response.data, { autoClose: 5000 });
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                });
            }
        });
    }

    handleDelete = () => {
        let { variableId } = this.state.view.formData;

        this.props.showLoading('Deleting variable, one moment please...').then(() => {
            this.props.deleteVariableRecord(variableId)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Successfully deleted the variable', { autoClose: 5000 })
                    }

                    let { search, missingLanguageId } = this.state;

                    let filterRequest: ILanguageVariableFilterRequest = {
                        languageMissing: missingLanguageId,
                        variable: search
                    };

                    this.props.getFilteredVariableReportList(filterRequest).then((response) => {
                        if (response.data.success) {
                            let listData = response.data.results;

                            this.setState({
                                listData,
                                view: {
                                    show: false,
                                    modalHeight: '',
                                    formData: variableId > 0 ? this.state.view.formData :
                                        {
                                            languageId: 0,
                                            variableId: 0,
                                            text: "",
                                            variable: ""
                                        }
                                },
                                deleteConfim: {
                                    show: false,
                                    modalHeight: '',
                                    variableId: 0
                                },
                                validation: {
                                    text: true,
                                    variable: true
                                }
                            });
                        }
                    });
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to process request: " + error.response.data, { autoClose: 5000 });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleAddEditCancel = () => {
        this.setState({
            view: {
                show: false,
                modalHeight: '',
                formData: {
                    languageId: 0,
                    variableId: 0,
                    variable: '',
                    text: ''
                }
            },
            validation: {
                variable: true,
                text: true
            }
        });
    }

    handleDeleteCancel = () => {
        this.setState({
            deleteConfim: {
                show: false,
                modalHeight: '',
                variableId: 0
            }
        });
    }

    handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let formData = _.cloneDeep(this.state.view.formData);

        let id = e.currentTarget.id;
        let value = e.currentTarget.value;


        if (id == 'variableId') {
            formData.variableId = parseInt(value);
        }

        if (id == 'text') {
            formData.text = value;
        }

        if (id == 'variable') {
            formData.variable = value;
        }

        this.setState({
            view: {
                ...this.state.view,
                formData
            }
        });
    };

    handleLanguageFieldChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let formData = _.cloneDeep(this.state.view.formData);
        let value = e.currentTarget.value;

        formData.languageId = parseInt(value);

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.getVariableText(formData)
                .then(response => {
                    if (response.data.success) {
                        let result = response.data.result;

                        formData.text = result;

                        this.setState({
                            view: {
                                ...this.state.view,
                                formData
                            }
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    };

    validate = () => {
        const isEdit = this.state.view.formData.variableId > 0 ? true : false;

        let validation: IValidation = {
            text: isEdit ? this.state.view.formData.text != "" : true,
            variable: isEdit ? true : this.state.view.formData.variable != ""
        };

        return validation;
    }

    isValid = () => {
        let { validation } = this.state;

        let isValid = validation.variable && validation.text;

        return isValid;
    }

    handleSearch = () => {
        let { search, missingLanguageId } = this.state;

        let filterRequest: ILanguageVariableFilterRequest = {
            languageMissing: missingLanguageId,
            variable: search
        };

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.getFilteredVariableReportList(filterRequest)
                .then(response => {
                    if (response.data.success) {
                        let results = response.data.results;

                        this.setState({
                            listData: results,
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }


    render = () => {
        const data = this.filteredData();

        if (data == null) {
            return null;
        }

        const languageList = this.state.lookupData ? this.state.lookupData.languageList : [];
        const isEdit = this.state.view.formData.variableId > 0 ? true : false;

        console.log(this.state.view.formData)

        return (
            <>
                <div ref={this.saveContainer} />

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div>
                        <h1 style={{ margin: 0 }}>DASH Language Variable List</h1>
                    </div>
                    <div>
                        <Button className='btn-block btn-sm' bsStyle="success" onClick={this.handleAddVariableReport}>Add New Variable</Button>
                    </div>
                </div>

                <Filter
                    languageId={this.state.missingLanguageId}
                    search={this.state.search}
                    languageList={languageList}
                    onLanguageChange={this.handleMissingLanguageChange}
                    onSearchChange={this.handleSearchChange}
                    onFilterSearch={this.handleSearch}
                />

                <GridWrapper className='ag-theme-bootstrap'>
                    <AgGridReact
                        onGridReady={this.onGridReady}
                        onGridSizeChanged={this.onGridSizeChanged}
                        onFirstDataRendered={(props: FirstDataRenderedEvent) => props.api.sizeColumnsToFit()}
                        rowData={this.state.listData}
                        headerHeight={30}
                        rowHeight={30}
                        enableCellChangeFlash={true}
                        suppressRowClickSelection={true}
                        suppressCellSelection={true}
                        suppressDragLeaveHidesColumns={true}
                        getRowNodeId={function (data) {
                            return data.id;
                        }}
                        rowStyle={{ overflow: 'visible', cursor: 'pointer' }}
                        columnDefs={this.columns}
                        noRowsOverlayComponentFramework={() => <div>There are no variables that match that criteria.</div>}
                        onSortChanged={(e: SortChangedEvent) => {
                            this.gridApi.refreshCells();
                        }}
                        onCellClicked={(props: CellClickedEvent) => {
                            let data = props.data as ILanguageVariableList;
                            this.handleEditVariableReport(data.id);
                        }}
                    />
                </GridWrapper>

                {this.state.listData !== null && (
                    <Modal show={this.state.view.show} bsSize="large" backdrop='static' onHide={this.handleAddEditCancel}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {isEdit ? 'Update' : 'Add'} Multilingual Variable
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormGroupWrapper validationState={this.state.validation.variable ? null : 'error'}>
                                <Col xs={12} lg={1} componentClass={ControlLabel}>Variable:</Col>
                                <Col xs={12} lg={8}>
                                    {isEdit ?
                                        <Label bsStyle={'success'} style={{ marginLeft: 5, padding: 5, fontSize: '100%' }}>{this.state.view.formData.variable}</Label>
                                        :
                                        <FormControl
                                            id='variable'
                                            style={{ width: 600 }}
                                            placeholder='Enter new label here'
                                            value={this.state.view.formData.variable}
                                            onChange={this.handleFieldChange}
                                        />
                                    }
                                </Col>
                            </FormGroupWrapper>

                            {isEdit && (
                                <>
                                    <FormGroupWrapper>
                                        <Col xs={12} lg={1} componentClass={ControlLabel}>Language:</Col>
                                        <Col xs={12} lg={8}>
                                            <FormControl
                                                componentClass='select'
                                                value={this.state.view.formData.languageId}
                                                onChange={this.handleLanguageFieldChange}
                                            >
                                                {languageList.map((language, index) =>
                                                    <option key={index} value={language.id}>{language.description}</option>
                                                )}
                                            </FormControl>
                                        </Col>
                                    </FormGroupWrapper>

                                    <FormGroupWrapper validationState={this.state.validation.text ? null : 'error'}>
                                        <Col xs={12} lg={1} componentClass={ControlLabel}>Text:</Col>
                                        <Col xs={12} lg={8}>
                                            <FormControl
                                                id='text'
                                                componentClass='textarea'
                                                style={{ height: 200, resize: 'none' }}
                                                placeholder='enter language text'
                                                value={this.state.view.formData.text}
                                                onChange={this.handleFieldChange}
                                            />
                                        </Col>
                                    </FormGroupWrapper>
                                </>
                            )}

                        </Modal.Body>
                        <Modal.Footer>
                            <Button bsStyle='primary' onClick={this.handleAddEditSave}> {isEdit ? 'Update' : 'Create New'} Variable</Button>
                            {isEdit ? <Button bsStyle='danger' onClick={() => this.handleDeleteModal(this.state.view.formData.variableId)}> Delete Variable</Button> : ""}
                            <Button onClick={this.handleAddEditCancel}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                )}

                <Modal show={this.state.deleteConfim.show} onHide={this.handleDeleteCancel}>
                    <Modal.Header style={{ borderBottom: '0 none' }}>
                        <h4 style={{ marginBottom: 0 }}>Are you sure you want to delete the following variable?</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='text-center'>
                            <Label bsStyle={'success'} style={{ marginLeft: 5, padding: 5, fontSize: '100%' }}>{this.state.view.formData.variable}</Label>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: '0 none' }}>
                        <Button onClick={this.handleDeleteCancel}>No, Cancel</Button>
                        <Button bsStyle='danger' onClick={this.handleDelete}>Yes, Delete</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getVariableReportList: () => {
            return dispatch(DashActionCreators.getVariableReportList());
        },
        getFilteredVariableReportList: (request) => {
            return dispatch(DashActionCreators.getFilteredVariableReportList(request));
        },
        getVariableReportLookupData: () => {
            return dispatch(DashActionCreators.getVariableReportLookupData());
        },
        getVariableText: (request) => {
            return dispatch(DashActionCreators.getVariableText(request));
        },
        saveVariableRecord: (request) => {
            return dispatch(DashActionCreators.saveVariableRecord(request));
        },
        deleteVariableRecord: (variableId) => {
            return dispatch(DashActionCreators.deleteVariableRecord(variableId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(VariableList);